export default __webpack_public_path__ + "images/qr-code-ico.svg";